import React from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const CircleBase = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
	width: token('space.400'),
	height: token('space.400'),
	borderRadius: 'border.radius.circle',
});

const marginStyles = xcss({ margin: 'space.025' });

export const EditorPresenceAvatarGroupLivePagePlaceholder = () => (
	<Flex testId="editor-presence-placeholder" xcss={marginStyles}>
		<Box xcss={CircleBase} />
	</Flex>
);
